export default __webpack_public_path__ + "images/236263a35a4885289579c02460ff03e5.png";